import React from 'react';
import LegalPageLayout, { LegalSection, LegalList } from '../components/LegalPageLayout';

const CookiePolicy: React.FC = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="April 17, 2026">
    <LegalSection title="1. What Are Cookies">
      <p>Cookies are small text files stored on your device when you visit a website. They help us provide a better experience by remembering your preferences and understanding how you use our services.</p>
    </LegalSection>

    <LegalSection title="2. How We Use Cookies">
      <p>Sahayy uses cookies for the following purposes:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Essential Cookies:</strong> Required for the website to function properly, including authentication and security.</>,
        <><strong style={{ color: "#111827" }}>Preference Cookies:</strong> Remember your settings such as language, theme, and community preferences.</>,
        <><strong style={{ color: "#111827" }}>Analytics Cookies:</strong> Help us understand how visitors interact with our website to improve the experience.</>,
      ]} />
    </LegalSection>

    <LegalSection title="3. Types of Cookies We Use">
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Session Cookies:</strong> Temporary cookies deleted when you close your browser.</>,
        <><strong style={{ color: "#111827" }}>Persistent Cookies:</strong> Remain on your device for a set period or until you delete them.</>,
        <><strong style={{ color: "#111827" }}>First-Party Cookies:</strong> Set by Sahayy directly.</>,
        <><strong style={{ color: "#111827" }}>Third-Party Cookies:</strong> Set by our service providers (e.g., analytics).</>,
      ]} />
    </LegalSection>

    <LegalSection title="4. Third-Party Services">
      <p>We may use the following third-party services that set cookies:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>AWS (Amazon Web Services):</strong> For authentication and infrastructure.</>,
        <><strong style={{ color: "#111827" }}>Stream Chat:</strong> For real-time messaging functionality.</>,
      ]} />
    </LegalSection>

    <LegalSection title="5. Managing Cookies">
      <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
      <LegalList items={[
        'View what cookies are stored and delete them individually',
        'Block third-party cookies',
        'Block cookies from specific sites',
        'Block all cookies',
        'Delete all cookies when you close your browser',
      ]} />
      <p>Please note that blocking or deleting cookies may affect the functionality of our services.</p>
    </LegalSection>

    <LegalSection title="6. Updates to This Policy">
      <p>We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
    </LegalSection>

    <LegalSection title="7. Contact Us">
      <p>If you have questions about our use of cookies, please contact us at <a href="mailto:care@sahayy.com" style={{ color: '#FF9900' }}>care@sahayy.com</a>.</p>
    </LegalSection>
  </LegalPageLayout>
);

export default CookiePolicy;
